<script>
  export let title
</script>

<div id="title">
  {#if title}
    {title}
  {:else}
    <slot />
  {/if}
</div>

<style>
  #title {
    font-size: 1.3rem;
    font-weight: bold;
  }
</style>